const i18nConfig = {
    locales: ['en','me'],
    defaultLocale: 'en'
}

module.exports = i18nConfig;